import {
    ComponentInjector,
    ComponentService,
    ComponentElements,
    ComponentSelector,
    ComponentSelectors,
    ComponentObject,
    UIComponent,
} from '@atypon/ui-utils'

class Texts extends ComponentObject { }

class ClassList extends ComponentObject {
    open = 'core-dropblock__content--open';
}

class Selectors extends ComponentSelectors {
    trigger = new ComponentSelector('.core-dropblock__trigger');
    content = new ComponentSelector('.core-dropblock__content');
}

class Elements extends ComponentElements<Selectors> {
    trigger: HTMLButtonElement;
    content: HTMLDivElement;

}

interface CoreDropblock extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class CoreDropblock implements UIComponent {
    protected isOpen: boolean;
  protected isTransitioning: boolean;

  constructor(protected wrapper: HTMLElement) { }

    initialize() {
        this.elements.initialize(this.wrapper);
        if (!this.elements.trigger || !this.elements.content) return;
        this.isOpen = false;
        this.isTransitioning = false;
        this.addEventListeners();
        return this;
    }


    addEventListeners(): void {
        this.domUtils.addEventListener(
            document, 
            "click", (e) => this.handleOutsideClick(e as MouseEvent)
        );
        this.domUtils.addEventListener(
            this.elements.trigger, 
            "click", (e) => this.toggleDropdown(e as MouseEvent)
        );
        this.domUtils.addEventListener(
            this.elements.trigger, 
            "keydown", (e) => this.handleKeyDown(e as KeyboardEvent)
        );
        this.domUtils.addEventListener(this.elements.content, "transitionend", () => {
            this.isTransitioning = false;
        });
    }

  protected toggleDropdown(event: MouseEvent) {
    if (this.isTransitioning)
        return;
    this.isTransitioning = true;
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    this.updateDropdownState();
  }

  protected updateDropdownState() {
    if (this.isOpen) {
        this.domUtils.addClasses(this.elements.content, this.classList.open);
        this.elements.trigger.setAttribute("aria-expanded", "true");
        this.elements.content.setAttribute("aria-hidden", "false");
        this.elements.content.style.height = `${this.elements.content.scrollHeight}px`;
      const firstFocusableElement = this.domUtils.getElement("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])", this.elements.content);
      firstFocusableElement?.focus();
    } else {
        this.elements.content.style.height = "0";
        this.domUtils.removeClasses(this.elements.content, this.classList.open);
      this.elements.trigger.setAttribute("aria-expanded", "false");
      this.elements.content.setAttribute("aria-hidden", "true");
    }
  }

  protected closeDropdown() {
    this.isOpen = false;
    this.updateDropdownState();
  }

  protected handleOutsideClick(event: MouseEvent) {
    if (!this.elements.content.contains(event.target as Node) && !this.elements.trigger.contains(event.target as Node)) {
      this.closeDropdown();
    }
  }

  protected handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Escape" && this.isOpen) {
      this.closeDropdown();
    } else if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleDropdown(event as any); 
    }
  }
}


export default CoreDropblock;

export {
    Selectors as CoreDropblockSelectors,
    Elements as CoreDropblockElements,
    ClassList as CoreDropblockClassList,
    Texts as CoreDropblockTexts
}